export enum ACCESS_LOG_TABLE_COLUMNS {
    USER = 'Source',
    TYPE = 'Type',
    PASSAGE = 'Passage',
    DATE = 'EventDate',
    RESULT = 'Result',
    AUTOMATION_ACTIVE = 'AutomationActive',
}

export const ACCESS_LOG_DEFAULT_SORT_COLUMN = ACCESS_LOG_TABLE_COLUMNS.DATE;
export const ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const ACCESS_LOG_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const ACCESS_LOG_PAGE_DEFAULT_SIZE = 20;

export const ACCESS_LOG_TABLE_HEADER = [
    ACCESS_LOG_TABLE_COLUMNS.USER,
    ACCESS_LOG_TABLE_COLUMNS.TYPE,
    ACCESS_LOG_TABLE_COLUMNS.PASSAGE,
    ACCESS_LOG_TABLE_COLUMNS.DATE,
    ACCESS_LOG_TABLE_COLUMNS.RESULT,
    ACCESS_LOG_TABLE_COLUMNS.AUTOMATION_ACTIVE,
];
